import { gql } from "@apollo/client";

export default gql`
  mutation deleteMeetingVideoRecordingMutation($meetingId: Int!) {
    deleteMeetingVideoRecording(meetingId: $meetingId) {
      meeting {
        id
        transcript {
          id
          videoRecording
          canSaveVideoRecording
          videoRecordingAvailableUntil
        }
      }
    }
  }
`;
